import React, { useState } from "react";
import { Formik, Form, Field, FieldArray, FastField } from "formik";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { useSelector, useDispatch } from "react-redux";
import * as Yup from "yup";
import { MdOutlineRemoveCircle } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import {getAuthorization} from "../../../../axios/AxiosAut";
import { addItemID } from "../../../../redux/slices/item/itemSlice";

// const validationSchema = Yup.object({
//   company_name: Yup.string()
//     .min(1, "Too short!")
//     .max(30, "Too long!")
//     .required("Company name is required"),
//   company_description: Yup.string().max(100, "Too long!"),
//   city: Yup.string().required("Required!"),
//   state: Yup.string().required("Required!"),
//   postal_code: Yup.string().required("Required!"),
//   country: Yup.string().required("Required!"),
// });

type Props = {
  HandleNext: () => void;
  HandleBack: () => void;
  ActiveStep: number;
};

function ItemsDetails(props: Props) {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user.currentUser);
  const Navigate = useNavigate();
  console.log("company detail", userData.email);
  const initialValues = {
    product_id: "",
    name: "",
    description: "",
    status: "",
    supplier: [],
  };

  
  const Permissions = useSelector((state) => state.user.userPermissions);
  const addsupplier = Permissions.find((o) => o.codename === "add_supplier");

  const onSubmit = (values, onSubmitProps) => {
    console.log("Form Data", values);
    getAuthorization()
      .post("product/create_item?type=item", values)
      .then((res) => {
        props.HandleNext();
        dispatch(addItemID(res.data));
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  const RemoveTemplateHandler = (remove, index) => {
    remove(index);
  };
  const AddTemplateHandler = (push) => {
    push({
      name: "",
      post_code: "",
      street_name: "",
      door_number: "",
      country: "",
      city: "",
      phone_number: "",
      email: "",
      website: "",
    });
  };
  return (
    <>
      <div className="min-h-full flex items-center justify-center sm:px-6 lg:px-8">
        <div className="w-full">
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            // validationSchema={validationSchema}
            // validateOnMount
          >
            <Form>
              <div className="grid space-y-10">
                <div className="grid grid-cols-2 gap-10">
                  <Field name="name">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="text"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-b-2 bg-default relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                }
                              : {
                                  className:
                                    "border-b-2 bg-default relative block w-full px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                })}
                            placeholder="Item Name"
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-semibold font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </Field>
                  <Field name="product_id">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="text"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-b-2 bg-default relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                }
                              : {
                                  className:
                                    "border-b-2 bg-default relative block w-full px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                })}
                            placeholder="Product ID"
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-semibold font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </Field>
                </div>
                <Field name="description">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <>
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 bg-default relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 bg-default relative block w-full px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Description"
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </>
                    );
                  }}
                </Field>
                <Field name="status">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <select
                        {...field}
                        className="form-select appearance-none
                            block
                            w-full
                            px-4
                            py-3
                            text-base
                            font-medium
                            bg-default bg-clip-padding bg-no-repeat
                            border border-solid border-gray-100
                            rounded-md
                            transition
                            text-gray-50
                            ease-in-out
                            m-0
                             focus:border-blue-100 focus:outline-none"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected hidden>
                          Status
                        </option>
                        <option value="active">Active</option>
                        <option value="discontinued">Discontinued</option>
                        <option value="phase_out">Phase out</option>
                      </select>
                    );
                  }}
                </Field>
                <Field name="warehouse">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <select
                        {...field}
                        className="form-select appearance-none
                            block
                            w-full
                            px-4
                            py-3
                            text-base
                            font-medium
                            text-gray-50
                            bg-default bg-clip-padding bg-no-repeat
                            border border-solid border-gray-100
                            rounded-md
                            transition
                            ease-in-out
                            m-0
                           focus:border-blue-100 focus:outline-none"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected hidden>
                          Warehouse
                        </option>
                      </select>
                    );
                  }}
                </Field>
                <Field name="">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <select
                        {...field}
                        className="form-select appearance-none
                            block
                            w-full
                            px-4
                            py-3
                            text-base
                            font-medium
                            text-gray-50
                            bg-default bg-clip-padding bg-no-repeat
                            border border-solid border-gray-100
                            rounded-md
                            transition
                            ease-in-out
                            m-0
                             focus:border-blue-100 focus:outline-none"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected hidden>
                          Supplier
                        </option>
                      </select>
                    );
                  }}
                </Field>
              </div>
              { !addsupplier ===undefined ||  addsupplier?.codename ===
              "add_supplier" ? (
              <FieldArray name="supplier">
                {(FieldArrayProps) => {
                  const { push, remove, form } = FieldArrayProps;
                  const { values } = form;
                  const { supplier } = values;
                  return (
                    <>
                      <div className="flex flex-row mt-3 space-x-2">
                        <button
                          type="button"
                          onClick={() => AddTemplateHandler(push)}
                        >
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="12.5"
                              cy="12.5"
                              r="12.5"
                              fill="#1F78B4"
                            />
                            <path
                              d="M6.66406 12.5013H18.3307M12.4974 6.66797V12.5013V18.3346"
                              stroke="white"
                              stroke-width="1.66667"
                            />
                          </svg>
                        </button>
                        <p className="text-blue-200">Add Suppliers</p>
                      </div>
                      {supplier.map((supplier, index) => (
                        <>
                          <div className="flex flex-col justify-center space-y-3 my-3">
                            <FastField name={`supplier.${[index]}.name`}>
                              {(props) => {
                                const { field, form, meta } = props;
                                return (
                                  <>
                                    <input
                                      {...field}
                                      type="text"
                                      {...(meta.touched && meta.error
                                        ? {
                                            className:
                                              "border-b-2 bg-default relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                          }
                                        : {
                                            className:
                                              "border-b-2 bg-default relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                          })}
                                      placeholder="Name"
                                      value={
                                        values.supplier[index].name === null ||
                                        values.supplier[index].name ===
                                          undefined
                                          ? ""
                                          : values.supplier[index].name
                                      }
                                    ></input>
                                    {meta.touched && meta.error ? (
                                      <label className="text-xs font-semibold font-Montserrat text-red-500">
                                        <span className="ml-1">
                                          {meta.error}
                                        </span>
                                      </label>
                                    ) : null}
                                  </>
                                );
                              }}
                            </FastField>
                            <div className="flex w-3/4 flex-row justify-between space-x-5">
                              <FastField
                                name={`supplier.${[index]}.phone_number`}
                              >
                                {(props) => {
                                  const { field, form, meta } = props;
                                  return (
                                    <>
                                      <input
                                        {...field}
                                        type="text"
                                        {...(meta.touched && meta.error
                                          ? {
                                              className:
                                                "border-b-2 bg-default relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                            }
                                          : {
                                              className:
                                                "border-b-2 bg-default relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                            })}
                                        placeholder="Contact Number"
                                        value={
                                          values.supplier[index]
                                            .phone_number === null ||
                                          values.supplier[index]
                                            .phone_number === undefined
                                            ? ""
                                            : values.supplier[index]
                                                .phone_number
                                        }
                                      ></input>
                                      {meta.touched && meta.error ? (
                                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                                          <span className="ml-1">
                                            {meta.error}
                                          </span>
                                        </label>
                                      ) : null}
                                    </>
                                  );
                                }}
                              </FastField>
                              <FastField name={`supplier.${[index]}.email`}>
                                {(props) => {
                                  const { field, form, meta } = props;
                                  return (
                                    <>
                                      <input
                                        {...field}
                                        type="text"
                                        {...(meta.touched && meta.error
                                          ? {
                                              className:
                                                "border-b-2 bg-default relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                            }
                                          : {
                                              className:
                                                "border-b-2 bg-default relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                            })}
                                        placeholder="Email"
                                        value={
                                          values.supplier[index].email ===
                                            null ||
                                          values.supplier[index].email ===
                                            undefined
                                            ? ""
                                            : values.supplier[index].email
                                        }
                                      ></input>
                                      {meta.touched && meta.error ? (
                                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                                          <span className="ml-1">
                                            {meta.error}
                                          </span>
                                        </label>
                                      ) : null}
                                    </>
                                  );
                                }}
                              </FastField>
                            </div>
                            <FastField name={`supplier.${[index]}.street_name`}>
                              {(props) => {
                                const { field, form, meta } = props;
                                return (
                                  <>
                                    <input
                                      {...field}
                                      type="text"
                                      {...(meta.touched && meta.error
                                        ? {
                                            className:
                                              "border-b-2 bg-default relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                          }
                                        : {
                                            className:
                                              "border-b-2 bg-default relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                          })}
                                      placeholder="Street Name"
                                      value={
                                        values.supplier[index].street_name ===
                                          null ||
                                        values.supplier[index].street_name ===
                                          undefined
                                          ? ""
                                          : values.supplier[index].street_name
                                      }
                                    ></input>
                                    {meta.touched && meta.error ? (
                                      <label className="text-xs font-semibold font-Montserrat text-red-500">
                                        <span className="ml-1">
                                          {meta.error}
                                        </span>
                                      </label>
                                    ) : null}
                                  </>
                                );
                              }}
                            </FastField>
                            <div className="flex w-3/4 flex-row justify-between space-x-5">
                              <FastField
                                name={`supplier.${[index]}.door_number`}
                              >
                                {(props) => {
                                  const { field, form, meta } = props;
                                  return (
                                    <>
                                      <input
                                        {...field}
                                        type="text"
                                        {...(meta.touched && meta.error
                                          ? {
                                              className:
                                                "border-b-2 bg-default relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                            }
                                          : {
                                              className:
                                                "border-b-2 bg-default relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                            })}
                                        placeholder="Door Number"
                                        value={
                                          values.supplier[index].door_number ===
                                            null ||
                                          values.supplier[index].door_number ===
                                            undefined
                                            ? ""
                                            : values.supplier[index].door_number
                                        }
                                      ></input>
                                      {meta.touched && meta.error ? (
                                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                                          <span className="ml-1">
                                            {meta.error}
                                          </span>
                                        </label>
                                      ) : null}
                                    </>
                                  );
                                }}
                              </FastField>
                              <FastField name={`supplier.${[index]}.post_code`}>
                                {(props) => {
                                  const { field, form, meta } = props;
                                  return (
                                    <>
                                      <input
                                        {...field}
                                        type="text"
                                        {...(meta.touched && meta.error
                                          ? {
                                              className:
                                                "border-b-2 bg-default relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                            }
                                          : {
                                              className:
                                                "border-b-2 bg-default relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                            })}
                                        placeholder="Post Code"
                                        value={
                                          values.supplier[index].post_code ===
                                            null ||
                                          values.supplier[index].post_code ===
                                            undefined
                                            ? ""
                                            : values.supplier[index].post_code
                                        }
                                      ></input>
                                      {meta.touched && meta.error ? (
                                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                                          <span className="ml-1">
                                            {meta.error}
                                          </span>
                                        </label>
                                      ) : null}
                                    </>
                                  );
                                }}
                              </FastField>
                            </div>
                            <div className="flex w-3/4 flex-row justify-between space-x-5">
                              <FastField name={`supplier.${[index]}.country`}>
                                {(props) => {
                                  const { field, form, meta } = props;
                                  return (
                                    <>
                                      <input
                                        {...field}
                                        type="text"
                                        {...(meta.touched && meta.error
                                          ? {
                                              className:
                                                "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                            }
                                          : {
                                              className:
                                                "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                            })}
                                        placeholder="Country"
                                        value={
                                          values.supplier[index].country ===
                                            null ||
                                          values.supplier[index].country ===
                                            undefined
                                            ? ""
                                            : values.supplier[index].country
                                        }
                                      ></input>
                                      {meta.touched && meta.error ? (
                                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                                          <span className="ml-1">
                                            {meta.error}
                                          </span>
                                        </label>
                                      ) : null}
                                    </>
                                  );
                                }}
                              </FastField>
                              <FastField name={`supplier.${[index]}.city`}>
                                {(props) => {
                                  const { field, form, meta } = props;
                                  return (
                                    <>
                                      <input
                                        {...field}
                                        type="text"
                                        {...(meta.touched && meta.error
                                          ? {
                                              className:
                                                "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                            }
                                          : {
                                              className:
                                                "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                            })}
                                        placeholder="City"
                                        value={
                                          values.supplier[index].city ===
                                            null ||
                                          values.supplier[index].city ===
                                            undefined
                                            ? ""
                                            : values.supplier[index].city
                                        }
                                      ></input>
                                      {meta.touched && meta.error ? (
                                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                                          <span className="ml-1">
                                            {meta.error}
                                          </span>
                                        </label>
                                      ) : null}
                                    </>
                                  );
                                }}
                              </FastField>
                            </div>
                            <FastField name={`supplier.${[index]}.website`}>
                              {(props) => {
                                const { field, form, meta } = props;
                                return (
                                  <>
                                    <input
                                      {...field}
                                      type="text"
                                      {...(meta.touched && meta.error
                                        ? {
                                            className:
                                              "border-b-2 bg-default relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                          }
                                        : {
                                            className:
                                              "border-b-2 bg-default relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                          })}
                                      placeholder="Website"
                                      value={
                                        values.supplier[index].website ===
                                          null ||
                                        values.supplier[index].website ===
                                          undefined
                                          ? ""
                                          : values.supplier[index].website
                                      }
                                    ></input>
                                    {meta.touched && meta.error ? (
                                      <label className="text-xs font-semibold font-Montserrat text-red-500">
                                        <span className="ml-1">
                                          {meta.error}
                                        </span>
                                      </label>
                                    ) : null}
                                  </>
                                );
                              }}
                            </FastField>

                            <div className="flex flex-row mt-3 space-x-2">
                              <button
                                type="button"
                                onClick={() =>
                                  RemoveTemplateHandler(remove, index)
                                }
                              >
                                <MdOutlineRemoveCircle
                                  size={27}
                                  color="#B91C1C"
                                />
                              </button>
                              <p className="text-red-700">Remove Supplier</p>
                            </div>
                          </div>
                        </>
                      ))}
                    </>
                  );
                }}
              </FieldArray>) : null }
              <Field>
                {(props) => {
                  const { field, form, meta } = props;
                  const { isSubmitting } = form;
                  return (
                    <>
                      <div className="flex items-center justify-center pt-8 sm:px-6 lg:px-8">
                        <div className="w-full space-y-8">
                          <div className="flex flex-row space-x-3 justify-center">
                            <div className="flex flex-col w-3/5">
                              <button
                                onClick={() =>
                                  Navigate("/dashboard/management/items")
                                }
                                type="button"
                                className="border-2 border-red-700 hover:text-white text-base font-Montserrat font-bold text-red-700 flex-shrink hover:border-red-700 hover:bg-red-700 place-content-center rounded-md px-2 py-1 flex flex-grow w-40 "
                              >
                                Cancel
                              </button>
                            </div>

                            <div className="flex flex-col w-1/5">
                              {props.ActiveStep > 0 ? (
                                <button
                                  onClick={props.HandleBack}
                                  type="button"
                                  className="border-2 border-blue-200 hover:text-white text-base font-Montserrat font-bold text-blue-200 flex-shrink hover:border-blue-100 hover:bg-blue-100 place-content-center rounded-md px-2 py-1 flex flex-grow w-40 "
                                >
                                  Previous Step
                                </button>
                              ) : null}
                            </div>

                            <div className="flex flex-col w-1/5">
                              {!isSubmitting ? (
                                <button
                                  type="submit"
                                  className="font-Montserrat font-semibold text-white bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1.5 flex flex-grow"
                                >
                                  Save
                                </button>
                              ) : (
                                <button
                                  disabled
                                  className="font-Montserrat font-semibold text-white bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1.5 flex flex-grow"
                                >
                                  <div className="flex items-center justify-center space-x-2 animate-pulse">
                                    <svg className="w-5 h-5 bg-green-50 rounded-full"></svg>
                                    <svg className="w-5 h-5 bg-green-50 rounded-full"></svg>
                                    <svg className="w-5 h-5 bg-green-50 rounded-full"></svg>
                                  </div>
                                </button>
                              )}
                            </div>
                          </div>
                        
                        </div>
                      </div>
                    </>
                  );
                }}
              </Field>
            </Form>
          </Formik>
        </div>
      </div>
    </>
  );
}

export default ItemsDetails;
